import { configureTheming } from "@tal-gel/theming";
import ThemingPluginTal from "@tal-gel/theming-plugin-tal/";
import { UiIcons as talUIIconsList } from "@tal-gel/theming-plugin-tal/dist/lite/ui-icons/main";

ThemingPluginTal.talUiIcons = talUIIconsList;
ThemingPluginTal.talBrandIcons = {};
ThemingPluginTal.talFonts = () => <></>;

configureTheming({
  plugins: [ThemingPluginTal],
});
